import { pick } from 'es-toolkit';
import { meta } from '../../../constants';
import type { FormFunctionality } from '../../../types';

const { alias } = meta;

type ExtendedFormFunctionality = FormFunctionality & {
  submitAdditionalData: { type: typeof alias };
};

export function getFormFunctionalitySettings<T extends FormFunctionality>(
  settings: T
): ExtendedFormFunctionality {
  return {
    ...pick(settings, [
      'autoresponderEI',
      'autoresponderActive',
      'autoresponderReceiver',
      'autoresponderSenderName',
      'autoresponderReplyTo',
      'autoresponderSubject',
      'autoresponderTemplate',
      'integrationGoogleSheets',
      'integrationGoogleSheetsAuth',
      'integrationGoogleSheetsId',
      'integrationMailchimp',
      'integrationMailchimpAuth',
      'mailActive',
      'mailReceivers',
      'mailSenderName',
      'mailSubject',
      'mailTemplate',
      'mailEI',
      'mailCC',
      'mailBCC',
      'mailReplyTo',
      'recaptcha',
      'fields',
      'integrationMailchimpFieldsMap',
      'submitButtonText',
      'submitMessageTitle',
      'submitMessageText',
      'submitAction',
      'submitRedirectURL',
      'submitMessageButton',
      'submitMessageButtonText',
      'integrationSMTP',
      'integrationMailchimpList',
      'integrationZapier',
      'webhooks',
      'integrationSettingsID',
      'integrationStripe',
      'checkoutSuccessTitle',
      'checkoutSuccessText'
    ]),
    submitAdditionalData: {
      type: alias
    }
  };
}
